const CHANNEL_NAME = 'deepmox-auth-session';
const MESSAGE_TYPE = 'auth-session-changed';

type AuthSessionMessage = {
	type: typeof MESSAGE_TYPE;
	version: 1;
};

let channel: BroadcastChannel | null = null;
const listeners = new Set<() => void>();

function ensureChannel(): BroadcastChannel | null {
	if (channel) return channel;
	if (typeof BroadcastChannel === 'undefined') return null;
	channel = new BroadcastChannel(CHANNEL_NAME);
	channel.addEventListener('message', (event: MessageEvent<unknown>) => {
		const message = event.data as Partial<AuthSessionMessage> | null;
		if (message?.type !== MESSAGE_TYPE || message.version !== 1) return;
		for (const listener of listeners) listener();
	});
	return channel;
}

/**
 * Keeps same-origin tabs honest when one tab replaces the shared HttpOnly
 * session cookie. The message intentionally carries no user, plan, or token.
 */
export function startAuthSessionSync(onRemoteChange: () => void): () => void {
	listeners.add(onRemoteChange);
	ensureChannel();
	return () => {
		listeners.delete(onRemoteChange);
		if (listeners.size === 0 && channel) {
			channel.close();
			channel = null;
		}
	};
}

export function announceAuthSessionChange(): void {
	ensureChannel()?.postMessage({ type: MESSAGE_TYPE, version: 1 } satisfies AuthSessionMessage);
}
